module.exports = __webpack_public_path__ + "img/german-bundesliga-8.c4f4456e.png";